import { render, staticRenderFns } from "./DownloadStudyButton.vue?vue&type=template&id=075d82d0&scoped=true&"
import script from "./DownloadStudyButton.vue?vue&type=script&lang=js&"
export * from "./DownloadStudyButton.vue?vue&type=script&lang=js&"
import style0 from "./DownloadStudyButton.vue?vue&type=style&index=0&id=075d82d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075d82d0",
  null
  
)

export default component.exports